
import React from "react";
function Header(){
    return(
        <>
        <div className="header">
            <h1>Magic Match </h1>
            <p>Mystic Matchup Madness</p>
        </div>
        </>
    );
}
export default Header;